var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81439 2.8145C4.14075 1.48817 5.97499 0.666626 7.99984 0.666626C10.0247 0.666626 11.8589 1.48817 13.1853 2.81451L12.7139 3.28591L13.1853 2.81451C14.5116 4.14087 15.3332 5.97511 15.3332 7.99996C15.3332 10.0248 14.5116 11.8591 13.1853 13.1854C11.8589 14.5117 10.0247 15.3333 7.99984 15.3333C5.97499 15.3333 4.14074 14.5117 2.81439 13.1854L3.28579 12.714L2.81438 13.1854C1.48805 11.8591 0.666504 10.0248 0.666504 7.99996C0.666504 5.97511 1.48805 4.14087 2.81438 2.81451L2.81439 2.8145ZM7.99984 1.99996C6.34282 1.99996 4.84373 2.6708 3.75719 3.75732C2.67067 4.84386 1.99984 6.34294 1.99984 7.99996C1.99984 9.65698 2.67068 11.1561 3.7572 12.2426C4.84373 13.3291 6.34282 14 7.99984 14C9.65686 14 11.1559 13.3291 12.2425 12.2426C13.329 11.1561 13.9998 9.65698 13.9998 7.99996C13.9998 6.34294 13.329 4.84385 12.2425 3.75732C11.1559 2.6708 9.65686 1.99996 7.99984 1.99996Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 3.66663C8.46007 3.66663 8.83317 4.03973 8.83317 4.49996C8.83317 4.96019 8.46007 5.33329 7.99984 5.33329C7.5396 5.33329 7.1665 4.96019 7.1665 4.49996C7.1665 4.03973 7.5396 3.66663 7.99984 3.66663Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8335 6.66667C6.8335 6.29848 7.13197 6 7.50016 6H8.16683C8.53502 6 8.8335 6.29848 8.8335 6.66667V11.3333C8.8335 11.7015 8.53502 12 8.16683 12C7.79864 12 7.50016 11.7015 7.50016 11.3333V7.33333C7.13197 7.33333 6.8335 7.03486 6.8335 6.66667Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 11.3333C6.3335 10.9651 6.63197 10.6666 7.00016 10.6666H9.3335C9.70169 10.6666 10.0002 10.9651 10.0002 11.3333C10.0002 11.7015 9.70169 12 9.3335 12H7.00016C6.63197 12 6.3335 11.7015 6.3335 11.3333Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleGray400);
export default __webpack_public_path__ + "static/media/info_circle_gray400.efb0aa2e9f9aa7e4fd7b24baaf6f6576.svg";
export { ForwardRef as ReactComponent };